export const processTicketsDataBeforeAddingInDb = (ticket: any) => {
  return {
    ...ticket,
    created_at_date: new Date(ticket.created_at),
    updated_at_date: new Date(ticket.updated_at),
  };
};
